/* eslint-disable no-unused-vars */
/* eslint-disable require-jsdoc */

import React, { useState, createRef, useRef, useEffect } from 'react';
// // import Modal from 'react-bootstrap/Modal';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Genre from './Genre';
import CalendarComponent from './CalendarComponent';
import Distance from './Distance';
import PropTypes from 'prop-types';
import { Popover as BootstrapPop, OverlayTrigger } from 'react-bootstrap';
import { debug } from '../../carousel-react/src/config';
import ActiveFilters from './ActiveFilters';
import { futureDates } from '../../carousel-react/src/utils/date';
import moment from 'moment';
import { A4map } from '../../hearbymap/src/A4map/A4map';

function newCurrDate(date) {
  const day = moment(date);
  const dayFormattedObj = day.clone().format('ddd, MMM DD');
  const dayFormattedStr = JSON.stringify(dayFormattedObj)
    .replace('"', "").replace('"', "");
  return dayFormattedStr;
}

const GenreNumber = ({ genreCount }) => (
  <span className='badge'>{genreCount}</span>
);
const GenreActive = ({ genreCount }) => {
  const activeText = genreCount > 0 ? 'Active' : 'All';
  return (
    <span className='badge-label'>{activeText}</span>
  )
};
const GenreCount = ({ genreCount }) => (
  <React.Fragment>
    {genreCount > 0 ? <GenreNumber genreCount={genreCount} /> : null}
    <GenreActive genreCount={genreCount} />
  </React.Fragment>
);

function CurrDateQuery(date) {
  // console.log(date);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = date.getFullYear();
  const dateStr = yyyy + '-' + mm + '-' + dd;
  // console.log(dateStr);
  return dateStr;

}
export default function Filters(props) {
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);
  const [genreCount, setGenreCount] = useState(0);
  const [activeCalendar, setActiveCalendar] = useState([new Date(), new Date()]);
  const [minDate, setMinDate] = useState(CurrDateQuery(new Date()));
  const [maxDate, setMaxDate] = useState(futureDates(props.defaultTimeFrame));
  const [hasDate, setHasDate] = useState(false);
  const [distance, setDistance] = useState(props.psBarSettings.distanceOpts.defaultDistance);
  const [datetext, setDatetext] = useState('');
  const [hasGenre, setHasGenre] = useState(false);
  const [genre, setGenre] = useState({
    Country: false,
    Comedy: false,
    Jazz: false,
    Rock: false,
    Classical: false,
    Pop: false,
    Electronic: false,
    Rap: false,
    Blues: false,
    International: false,
    Folk: false
  });
  debug && console.log(genre);
  const initialDistanceFilters = {
    walk: false,
    bus: false,
    dist: false,
  };
  const handleGenreReset = () => {
    setHasGenre(false);
    setGenre({
      Country: false,
      Comedy: false,
      Jazz: false,
      Rock: false,
      Classical: false,
      Pop: false,
      Electronic: false,
      Rap: false,
      Blues: false,
      International: false,
      Folk: false
    })
    //  setGenreText('');
    setGenreCount(0);
  }

  const incActiveFilterCount = () => {
    setActiveFiltersCount(activeFiltersCount + 1);
  }
  const decActiveFilterCount = () => {
    if (activeFiltersCount > 0) {
      setActiveFiltersCount(activeFiltersCount - 1);
    } else {
      debug && console.log('active filter counter wants to go negative');
    }
  }
  const incActiveGenreCount = () => {
    setGenreCount(genreCount + 1);
  }
  const decActiveGenreCount = () => {
    if (genreCount > 0) {
      setGenreCount(genreCount - 1);
    } else {
      debug && console.log('active genre filter counter wants to go negative');
    }
  }
  const resetCount = () => {
    setActiveFiltersCount(0);
  }
  const activeFilterCounter = {
    inc: incActiveFilterCount,
    dec: decActiveFilterCount,
    reset: resetCount
  }
  const activeGenreCounter = {
    inc: incActiveGenreCount,
    dec: decActiveGenreCount
  }
  const genreObj = {
    Country: 'Country,',
    Comedy: 'Comedy,',
    Jazz: 'Jazz,',
    Rock: 'Rock,',
    Classical: 'Classical,',
    Pop: 'Pop,',
    Electronic: 'Electronic,',
    Rap: 'Rap,',
    Blues: 'Blues,',
    International: 'International,',
    Folk: 'Folk,'
  }
  const onChangeAll = (event) => {
    let filterStr = '';
    debug && console.log('checkbox event ', event);
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    debug && console.log('checkbox val ', value);
    // value ? activeFilterCounter.inc() : activeFilterCounter.dec();
    value ? activeGenreCounter.inc() : activeGenreCounter.dec();
    debug && console.log('setting genre', event.target.name);
    setGenre({ ...genre, [event.target.name]: value, });
    setHasGenre(true);
    // setGenreText(event.target.name);
  };

  const handleCalendarChange = (dates) => {
    setActiveCalendar(dates);
    setMinDate(CurrDateQuery(dates[0]));
    setMaxDate(CurrDateQuery(dates[1]));
    debug && console.log(minDate, maxDate);
    setHasDate(true);
    setDatetext(`${newCurrDate(dates[0])} -  ${newCurrDate(dates[1])}`);
    if (!hasDate) {
      activeFilterCounter.inc();
    }
  }

  useEffect(() => {
    debug && console.log('Filters.jsx props.searchVal', props.searchVal);
    debug && console.log("search submit1 is ", props.searchSubmit);
    debug && console.log("search1 is ", props.searchVal);
    if (props.eventsubmit || (props.eventsearchsubmit && props.searchVal.length > 0)) {
      window.changeReactCarouselData(`lat=` + props.lat, `&lon=` + props.lon,
        `&min_date=` + minDate, `&max_date=` + maxDate, `&search=` + props.searchVal,
        JSON.stringify(genre), `&distance=` + distance);
      debug && console.log("search1 query ", `lat=` + props.lat, `&lon=` + props.lon,
        `&min_date=` + minDate, `&max_date=` + maxDate, `&search=` + props.searchVal,
        JSON.stringify(genre), `&distance=` + distance);
      props.eventsubmit ? props.setEventSubmit(false) : props.setEventSubmit(false);
      props.eventsearchsubmit ? props.setEventSearchSubmit(false) : props.setEventSearchSubmit(false);
    }

    if (props.submit || (props.searchSubmit && props.searchVal.length > 0)) {
      window.changeReactCarouselData(`lat=` + props.lat, `&lon=` + props.lon,
        `&min_date=` + minDate, `&max_date=` + maxDate, `&search=` + props.searchVal,
        JSON.stringify(genre), `&distance=` + distance);
      debug && console.log("search1 query ", `lat=` + props.lat, `&lon=` + props.lon,
        `&min_date=` + minDate, `&max_date=` + maxDate, `&search=` + props.searchVal,
        JSON.stringify(genre), `&distance=` + distance);
        //window.aMap.map.zoom, props.lat, props.lon, addVenues, window.aMap.map, distance, minDate, maxDate, genre)
      
      if(mapChanged(distance, minDate, maxDate, genre, props.lat, props.lon, A4map)) {
        A4map.get.distance = distance;
        A4map.get.minDate = minDate;
        A4map.get.maxDate = maxDate;
        A4map.get.genre = genre;
        A4map.get.fromPowersearch = true;
        A4map.get.changeLocation(props.lat, props.lon);
      }

      props.submit ? props.setSubmit(false) : props.setSearchSubmit(false)
    }
  }, [props.submit, props.searchSubmit, props.lat, props.lon, distance,
    minDate, maxDate, genre, props.searchVal, props.eventsearchsubmit]);

  const GenreNumber = ({ genreCount }) => (
    <span className='badge'>{genreCount}</span>
  );
  const mapChanged = (distance, minDate, maxDate, genre, lat, lon, A4map) => {
    const distChanged = distance !== A4map.get.distance;
    const minDateChanged = minDate !== A4map.get.minDate;
    const maxDateChanged = maxDate !== A4map.get.maxDate;
    const genreChanged = genre !== A4map.get.genre;
    const latChanged = lat !== A4map.get.loc.lat;
    const lonChanged = lon !== A4map.get.loc.lng;
    
    return (distChanged || minDateChanged || maxDateChanged || genreChanged ||
              latChanged || lonChanged) ? true : false;

  }
  const ActiveFilter = () => {
    return (
      <div className='hearby-af hearby-genrefilter'>
        <div onClick={() => handleGenreReset()} className='hearby-activegenre'>x</div>
      </div>
    );
  }

  const GenreActive = ({ genreCount }) => {
    const activeText = genreCount > 0 ? 'Active' : 'All';
    return (
      <span className='badge-label'>{activeText}</span>
    )
  };
  const GenreCount = ({ genreCount }) => (
    <React.Fragment>
      {genreCount > 0 ? <GenreNumber genreCount={genreCount} /> : null}
      <GenreActive genreCount={genreCount} />
    </React.Fragment>
  );




  const genrePopover = (
    <BootstrapPop className="popover-genre">
      <BootstrapPop.Title>
        Genre
      <div className="hearby-genre-exit" onClick={() => document.body.click()}>X</div>
      </BootstrapPop.Title>
      <BootstrapPop.Content>
        <ActiveFilters hasGenre={hasGenre} resetGenre={handleGenreReset} />
        <Genre onChange={onChangeAll} selected={genre} />
      </BootstrapPop.Content>
    </BootstrapPop>
  );
  const datePopover = (
    <BootstrapPop className="popover-date">
      <BootstrapPop.Title>
        Date
      <div className="hearby-calendar-exit" onClick={() => document.body.click()}>X</div>
      </BootstrapPop.Title>
      <BootstrapPop.Content>
        <ActiveFilters hasGenre={hasGenre} resetGenre={handleGenreReset} />
        <CalendarComponent date={activeCalendar} setDate={handleCalendarChange} />
      </BootstrapPop.Content>
    </BootstrapPop>
  );
  return (
    <React.Fragment>
      <div className="hearby-powersearch-area hearby-powersearch-date">
        <div className="hearby-powersearch-title hearby-powersearch-date-title">When?</div>
        <OverlayTrigger trigger='click' placement="bottom" overlay={datePopover} rootClose={true}>
          <div className="hearby-powersearch-text hearby-powersearch-date-text" type="button">
            {newCurrDate(minDate)} - {newCurrDate(maxDate)}</div>
        </OverlayTrigger>
      </div>
      <div className="hearby-powersearch-area hearby-powersearch-genre">
        <div className="hearby-powersearch-title hearby-powersearch-genre-title">Genre</div>
        <OverlayTrigger trigger='click' placement="bottom" overlay={genrePopover} rootClose={true}>
          <div className="hearby-powersearch-text hearby-powersearch-genre-text" type="button">
            <GenreCount genreCount={genreCount} /></div>
        </OverlayTrigger>
        {genreCount > 0 ? <ActiveFilter /> : null}
      </div>
      <div className="hearby-powersearch-area hearby-powersearch-distance">
        <div className="hearby-powersearch-title hearby-powersearch-distance-title">Distance</div>
        <Distance setDistance={setDistance}
          setActiveFilters={props.setActiveFilters}
          activeFilters={props.activeFilters}
          psBarSettings={props.psBarSettings}
        />
      </div>
    </React.Fragment>
  );
}
Filters.propTypes = {
  searchVal: PropTypes.string,
  flag: PropTypes.bool,
  lat: PropTypes.number,
  lon: PropTypes.number,
}